import app from './feathers';
import axios from 'axios';
import { mediaStore } from '../stores/mediaStore';
import { get } from 'svelte/store';
import { applicationConfigStore } from '../stores/applicationConfigStore';
const url = get(applicationConfigStore).apiUrl;
const uploadService = app.service('uploads');
const config = {
    onUploadProgress: function (progressEvent) {
        var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        console.log(percentCompleted);
    },
};
const methods = {
    async upload(file) {
        const res = await axios.post(url + '/uploads', file, config);
        mediaStore.add(res.data);
        return res;
    },
    async remove(id) {
        const res = await uploadService.remove(id);
        mediaStore.remove(res.id);
        return res;
    },
};
export default methods;
